import { render, staticRenderFns } from "./SectionReason.vue?vue&type=template&id=011cfe3f&"
import script from "./SectionReason.vue?vue&type=script&lang=js&"
export * from "./SectionReason.vue?vue&type=script&lang=js&"
import style0 from "./SectionReason.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports